import { StyleSheet, ActivityIndicator } from 'react-native'
import React from 'react'
import { useLoading } from '@context/LoadingContext/LoadingContext'
import { COLORS } from '@utils/colors'
import { LoadingProps } from '@Interfaces/Component/LoadingInterface'

const Loading: React.FC<LoadingProps> = () => {
  const { loading } = useLoading()

  if (!loading) return null

  return (
    <ActivityIndicator
      animating={loading}
      size={'large'}
      style={[StyleSheet.absoluteFill, { zIndex: 100 }]}
      color={COLORS.primary.blue}
    />
  )
}

export default Loading
